const en = {
    product_identification:'Unique identification code of the product type:',
    manufacturer: 'Manufacturer and Authorized Representative',
    product_type:'Select product type',

    core_type:'Select core type:',

    application:'Intended use',

    system:'System(s) of assessment and verification of constancy of performance:',

    harmonized_standard:'Harmonized standard:',

    notified_body:'Notified body/bodies:',

    technical_document:'European technical assessment document:',

    fire_and_resistance:'II) Reaction to fire:',

    fire_reaction:'Reaction to fire',

    declaration:'Declaration of Performance',

    face_back_material:'Material, external/internal facing',

// MAIN SECTIONS
    basic_information: 'General Information',
    fire_resistance: 'Reaction and Fire Resistance',
    material: 'Material',
    characteristics: 'Essential Characteristics',
// TABLE HEADERS
    characteristic: 'Essential Characteristics',
    value: 'Value',
    standard: 'Document / Standard',

// CHARACTERISTICS
    u_value:
        'VI) Thermal transmittance coefficient U-value',
    lambda:
        'VII) Thermal conductivity coefficient of the core',
    mechanical_resistance:
        'VIII) Mechanical resistance',
    zatezna_cvrstoca:
        'a) Tensile strength',
    modul_zatezanja:
        'b) Tensile modulus',
    zatezna_temp:
        'c) Tensile strength at elevated temperature',
    modul_temp:
        'd) Tensile modulus at elevated temperature',
    pritisna:
        'e) Compressive strength',
    modul_pritiska:
        'f) Compression modulus',
    smicanje:
        'g) Shear strength',
    smicanje_dugotrajno:
        'h) Reduced long-term shear strength',
    modul_smicanja:
        'i) Shear modulus',
    puzanje_2000:
        'j) Creep coefficient t=2,000h',
    puzanje_100000:
        'k) Creep coefficient t=100,000h',
    l_group:
        'l) Bending moment capacity of simply supported panel',

    l_pozitivno:
        'Positive',
    l_pozitivno_temp:
        'Positive, elevated temperature',
    l_negativno:
        'Negative',
    l_negativno_temp:
        'Negative, elevated temperature',
    m_group:
        'm) Relation between bending moment and support reactions',
    m_kapacitet:
        'Bending moment capacity',
    m_pozitivno:
        'Positive',
    m_pozitivno_temp:
        'Positive, elevated temperature',
    m_negativno:
        'Negative',
    m_negativno_temp:
        'Negative, elevated temperature',
    n_group:
        'n) Wrinkling stress - upper sheet',
    n_u_polju:
        'In field',
    n_u_polju_temp:
        'In field, elevated temperature',
    n_srednji_oslonac:
        'At intermediate support',
    n_srednji_oslonac_temp:
        'At intermediate support, elevated temperature',
    o_group:
        'o) Wrinkling stress - lower sheet',

    o_u_polju:
        'In field',
    o_srednji_oslonac:
        'At intermediate support',
    ix_pozar:
        'IX) External fire exposure',
    x_voda:
        'X) Water permeability',
    xi_zrak:
        'XI) Air permeability',
    xii_para:
        'XII) Water vapour permeability',
    xiii_zvuk:
        'XIII) Airborne sound insulation',
    xiv_apsorpcija:
        'XIV) Sound absorption',
    xv_trajnost:
        'XV) Durability',
    xvi_test:
        'XVI) Fastener test',
    dokumentacija:
        '8. Appropriate technical documentation and/or specific technical',

    signed_for: 'Signed for and on behalf of the manufacturer by:',
    footer_declaration:
        'The performance of the product identified above is in conformity with the set of declared performance/s. This declaration of performance is issued, in accordance with Regulation (EU) No 305/2011, under the sole responsibility of the manufacturer identified above. \t\t\t\t\t\t\t\t\t\t\t\t\n' +
        '\n' +
        '1 Fire resistance test documentation is issued at the customer\'s request)\n' +
        '2 Bending moment capacities are given for sheet thickness 0.4/0.4)\n' +
        '3 In accordance with EN-14509, EN-13165 and the materials used, following performance is confirmed without testing\n' +
        '\n',

    npd_translation:
        'No performance declared',

    thickness: 'Thickness',
    general_manager: 'General Manager',

    toplotna_otpornost:
        'Thermal resistance',

    toplotna_provodljivost:
        'Thermal conductivity',

    tolerancije_debljine_group:
        'V) Thickness tolerances',

    kategorija_tolerancije:
        'Tolerance category',

    plus_tolerancija:
        'Positive tolerance [+mm]',

    minus_tolerancija:
        'Negative tolerance [-mm]',

    reakcija_na_vatru_group:
        'VI) Reaction to fire',

    performance_class:
        'Performance class',

    smoke_classification:
        'Classification for smoke production',

    flaming_droplets:
        'Classification for flaming droplets',

    izdrzljivost_group:
        'VIII) Durability',

    dimenzionalna_stabilnost:
        'Dimensional stability',

    deformacija_pod_opterecenjem:
        'Deformation under load',

    cvrstoca_na_pritisak:
        'IX) Compressive strength (CS(10/Y)100, NPD)',

    cvrstoca_na_zatezanje:
        'X) Tensile strength',

    vodopropusnost_group:
        'XII) Water permeability',

    kratkotrajna_apsorpcija_vode:
        'Short-term water absorption',

    dugotrajna_djelimicna_apsorpcija:
        'Long-term partial water absorption',

    dugotrajna_potpuna_apsorpcija:
        'Long-term total water absorption',

    ravnost_nakon_kvasenja:
        'Flatness after wetting',

    paropropusnost:
        'XIII) Water vapour permeability',

    indeks_apsorpcije_zvuka:
        'XIV) Sound absorption index',

    ispustanje_opasnih_materija:
        'XV) Release of hazardous substances',

    kontinuirano_uzareno_izgaranje:
        'XVI) Continuous glowing combustion',

    application_14509_wall:
        'Metal-faced insulated sandwich panel for use in construction - Walls and wall cladding',

    application_14509_roof:
        'Metal-faced insulated sandwich panel for use in construction - Roofs and roof cladding',

    application_14509_coldroom:
        'Metal-faced insulated sandwich panel for use in construction - Cold room panel',

    application_13165:
        'Thermal insulation boards for use in buildings - Insulation of floors, walls and roofs',

    laminirana_folija:
        'Laminated foil',
}
export default en